import React from 'react';
import { CONTAINER_MAX_WIDTH, MEDIA_QUERY_MIN_MD } from '../../styled-components/layout/constants';
import { getStyle } from './helper';

interface ImagePreviewProps {
  image: string;
  imageLarge: string;
  webp?: string;
  webpLarge?: string;
  imageAlt?: string;
  proportions: number;
  index: number;
  onFullscreen?: (index: number) => void;
}

const ImagePreview = ({
  image,
  imageLarge,
  webp,
  webpLarge,
  imageAlt,
  proportions,
  onFullscreen,
  index,
}: ImagePreviewProps) => {
  const imageSizes = `
        (min-widht: ${CONTAINER_MAX_WIDTH}) 837px,
        (min-width: ${MEDIA_QUERY_MIN_MD}) calc(66.66667vw - 112px),
        100vw
    `;

  return (
    <div
      className="slick-slide-item"
      onClick={onFullscreen ? () => onFullscreen(index) : undefined}
    >
      <div className="slick-slide-image-container" style={getStyle(proportions)}>
        <picture>
          {webp && webpLarge && (
            <source
              type="image/webp"
              srcSet={`${webp} 800w, ${webpLarge} 1170w`}
              sizes={imageSizes}
            />
          )}
          <img
            src={image}
            srcSet={`${imageLarge} 1170w`}
            alt={imageAlt}
            sizes={imageSizes}
            className="slick-slide-image"
          />
        </picture>
      </div>
    </div>
  );
};

export default ImagePreview;
